<template>
  <div>
    <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0">

    <!-- 头部区域start -->
    <header class="header">
      <a @click="onClickLeft" style="color: white">返回</a>
      <span>{{ this.club }}<a href="#"><i></i></a></span>
      <a><i></i></a>
    </header>
    <div class="banner">
      <img src="http://cdn.sport.hhstu.xyz/club_banner.png" alt="">
    </div>
    <!-- 导航 -->
    <div class="nav">
      <div class="nav-top">
        <span><a href="">预约<br>记录</a></span>
        <span><a href="">训练<br>记录</a> </span>
        <span><a href="">俱乐部<br>首页</a><i></i></span>
        <span><a href="">晋级<br>报名</a> </span>
        <span><a href="">俱乐部<br>章程</a> </span>
        <span><a href="">组织<br>机构</a></span>
      </div>
      <div class="pic">
        <div class="pic-left">
          <div class="name">
            <span>姓名：{{ this.$cookies.get("info").sName }}</span>
            &nbsp;
            <span>等级：{{ this.ranks }}</span>
          </div>
          <div class="sport">
            <!--            <span>{{ this.club }}</span>-->
            &nbsp;
            <span>俱乐部完成度:</span>
          </div>
          <p style="text-align: center;font-size: 30px;color: #c2ffd8">{{ getRate }}%</p>
          <!--          <div class="progress"></div>-->
        </div>
        <div class="pic-right">
          <img src="http://cdn.sport.hhstu.xyz/club_1.png" alt="">
          <span>
                    预约记录
                </span>
          <!--          <img src="../../../assets/img/home/test/spot.png" alt="">-->
        </div>

      </div>

      <!-- 通知 -->
      <div class="inform">
        <div class="inform-detail">
          <span>通知</span>
          <span>体侧健康成绩更新啦！</span>
        </div>
        <div class="inform-more">
          <span><a href="">更多</a> </span>
          <i></i>
        </div>
      </div>
    </div>

    <div class="club-culture">
      <span>俱乐部文化</span>
      <div class="club-pic">
        <a href="https://mp.weixin.qq.com/s/P4YbuYVdb6AD19wVabv4DQ">
          <div class="club-pic1">
            <img src="http://cdn.sport.hhstu.xyz/club_b.jpg" alt="">
            <h3>什么！科大惊现「武林</h3>
            <span>接下来
我们正式介绍
「瑜伽门派」</span>
          </div>
        </a>
        <a href="https://mp.weixin.qq.com/s/JUxJBONV_Z3p1u5ygacqbA">
          <div class="club-pic2">
            <img src="http://cdn.sport.hhstu.xyz/club_a.jpg" alt="">
            <h3>体质健康测试紧急通知</h3>
            <span>我校2020年度大学生体测所有数据已经上传并可以查询。</span>
          </div>
        </a>
      </div>
    </div>

    <div class="club-activity">
      <span>俱乐部活动</span>
      <a href="https://mp.weixin.qq.com/s/IFURwgexC5KvwiQXgnAJhw">
        <div class="content">
          <img src="http://cdn.sport.hhstu.xyz/club_c.jpg" alt="">
          <div class="txt">
            <h3>体质健康测试视力情况采集</h3>
            <span>如若不知道自己的视力情况，请到东田径场体测中心进行测量，为了保证同学们的正常测试，体测中心全天开放。</span>
          </div>

        </div>
      </a>
    </div>
    <van-popup v-model="shows">
      <van-button type="warning">退出俱乐部</van-button>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Popup, Button
} from 'vant';

Vue.use(Popup);
Vue.use(Button);
import {GetClubInfo} from "@/network/student";

export default {
  name: "ClubDetail",
  data() {
    return {
      // club
      club: "",
      clubDescription: "",
      clubSelect: false,
      clubShow: false,
      ranks: 1,
      ClubTeacher: "",
      etime: 0,

      shows: false,
    }
  },
  activated() {
    GetClubInfo().then(res => {
      this.club = res.club;
      this.clubDescription = res.des;
      this.clubSelect = res.select;
      this.ranks = res.ranks;
      this.ClubTeacher = res.ClubTeacher;
      this.etime = res.etime;
    })
  },
  computed: {
    getRate() {
      if (this.$cookies.get("info").gId == '2019') {
        return Math.round(this.etime * 100 / (14 * 60))
      } else {
        return Math.round(this.etime * 100 / (10 * 60))
      }
    },
    getEtime() {
      return Math.floor(this.etime / 60) + '小时' + this.etime % 60 + '分钟'
    }
  },
  methods: {
    onClickLeft() {
      this.$router.replace("/home");
    },
    abc() {
      this.shows = true;
    }
  }
}
</script>

<style scoped>
body {
  min-width: 320px;
  max-width: 750px;
  margin: 0 auto;
  height: 1200px;
  background-color: #d4dada;
}

@font-face {
  font-family: 'icomoon';
  src: url('../../../assets/fonts/icomoon.eot?7kkyc2');
  src: url('../../../assets/fonts/icomoon.eot?7kkyc2#iefix') format('embedded-opentype'), url('../../../assets/fonts/icomoon.ttf?7kkyc2') format('truetype'), url('../../../assets/fonts/icomoon.woff?7kkyc2') format('woff'), url('../../../assets/fonts/icomoon.svg?7kkyc2#icomoon') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'self';
  src: url('../../../assets/fonts/incline.ttf');
  /*src: url('http://cdn.sport.hhstu.xyz/incline.ttf');*/
}

html {
  min-width: 375px;
}

a {
  text-decoration: none;
  color: #333;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}

.header {
  display: flex;
  height: 45px;
  width: 100%;
  background-color: #D4DADA;
  justify-content: center;
  align-items: center;
  font-family: 'icomoon';
}

.header span {
  font-size: 25px;
  font-family: 'self';
  color: #ADADAD;
  text-align: center;
  flex: 3;
}

.header span a i {
  vertical-align: middle;
}

.header i {
  font-family: 'icomoon';
  color: #BBBBBE;
  font-style: normal;
}

.header a:first-child {
  text-align: center;
  flex: 1;
}

.header a:last-child {
  text-align: center;
  flex: 1;
}

.banner img {
  height: 150px;
  width: 100%;
}

/* 导航start */
.nav {
  font-family: 'self';
  width: 100%;
  height: 200px;
  background-color: #e1e4e4;
}

.nav-top {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.nav .nav-top span {
  position: relative;
  padding-top: 15px;
  height: 80px;
  font-size: 18px;
  flex: 1;
}

.nav .nav-top span a {
  color: #888989;
}

.nav .nav-top span:first-child {
  padding-left: 5px;
  padding-right: 5px;
}

.nav .nav-top span:nth-child(3) {
  font-style: normal;
  background-color: #4fd2c2;
}

.nav .nav-top span a::after {
  position: absolute;
  background-color: #e1e4e4;
  content: '';
  border-radius: 50%;
  width: 5px;
  height: 5px;
  left: 50%;
  bottom: 10px;
}

.nav .nav-top span:nth-child(3) a::after {
  background-color: #fff;
}

.nav .nav-top span:nth-child(1) a::after {
  background-color: #4fd2c2;
}

.nav .nav-top span:nth-child(2) a::after {
  background-color: #4fd2c2;
}

.nav .pic {
  height: 100px;
  margin: 5px 0 0 0;
  display: flex;
  justify-content: space-around;
}

.nav .pic-left {
  position: relative;
  float: left;
  flex: 1.5;
  /* height: 100px; */
  border-radius: 50px;
  padding-top: 10px;
  padding-left: 32px;
  background-color: #16c5b1;
}

.nav .pic-left .name,
.sport,
p {
  font-size: 18px;
  color: #fff;
}

.nav .pic-left .name,
.sport,
p {
  margin-top: -1px;
}

.nav .pic-left .sport span:first-child {
  font-size: 26px;
}

.nav .pic-left p {
  text-align: right;
  padding-right: 20px;
}

.nav .pic-left .progress {
  position: absolute;
  width: 70%;
  height: 12px;
  left: 35px;
  bottom: 10px;
  background-color: #fff;
}

.nav .pic-left .progress::before {
  content: '';
  display: block;
  width: 116.55px;
  height: 12px;
  background-color: #038576;
}

.nav .pic-right {
  flex: 1;
  position: relative;
}

.nav .pic-right img {
  height: 100px;
  margin-left: 10px;
}

.nav .pic-right span {
  display: inline-block;
  width: 74px;
  position: absolute;
  color: #16c5b1;
  font-size: 20px;
  left: 15px;
  top: 20px;
}

.nav .pic-right img:last-child {
  position: absolute;
  width: 30px;
  height: 10px;
  right: 25px;
  top: 76px;
  color: transparent;
}

.pic::after {
  content: '';
  display: table;
  clear: both;
}

/* 导航end */
/* 通知部分start */
.inform {
  width: 100%;
  height: 50px;
  margin-top: 30px;
  background-color: #fff;
  line-height: 50px;
}

.inform-detail {
  float: left;
}

.inform-more {
  float: right;
}

.inform .inform-detail span:first-child {
  display: inline-block;
  color: #fff !important;
  margin-left: 10px;
  padding-left: 18px;
  width: 80px;
  height: 35px;
  line-height: 35px;
  border-radius: 8px 0 8px 0;
  font-size: 20px;
  background-color: #16c5b1;
}

.inform .inform-detail span:nth-child(2) {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 500;
}

.inform .inform-more {
  margin-right: 20px;
  /* background-color: red; */
}

.inform .inform-more span a {
  font-size: 18px;
  color: #767676;
}

.inform .inform-more i {
  font-style: normal;
  font-size: 20px;
  vertical-align: bottom;
  color: #767676;
  font-family: 'icomoon';
}

/* 通知部分end */
/* 俱乐部文化culture-start */
.club-culture {
  font-family: 'self';
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}

.club-culture .club-pic {

  font-family: '楷体';
  display: flex;
  justify-content: space-around;
  text-align: center;
}

.club-culture .club-pic h3 {
  font-size: 16px;
  margin: 5px 0 5px 0;
  padding: 0 0 0 5px;
}

.club-culture .club-pic span {
  background-color: #fff;
  display: inline-block;
  color: #6c6c6c;
  font-size: 12px;
  width: 170px;
  margin: 0 0 5px 0;
  padding: 0 0 0 5px;
}

.club-culture span:first-child {
  font-size: 20px;
  padding: 10px 0 0 18px;
  margin-bottom: 8px;
  font-weight: bold;
}

.club-culture .club-pic .club-pic1 img {
  width: 170px;
  height: 100px;
}

.club-culture .club-pic .club-pic2 img {
  width: 170px;
  height: 100px;
}

.club-culture .club-pic .club-pic1,
.club-pic2 {
  background-color: #fff;
}

/* 俱乐部文化culture-end */
/* 俱乐部活动-start */
.club-activity {
  font-family: 'self';

  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 8px;
}

.club-activity .content {
  font-family: '微软雅黑';
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.club-activity span:first-child {
  font-family: 'self';
  font-size: 20px;
  padding: 0 0 0 18px;
  margin-bottom: 10px;
  font-weight: bold;
}

.club-activity .content img {
  margin: 0 auto;
  width: 90%;
}

.club-activity .content .txt {
  text-align: center;
  background-color: #fff;
  margin: 0 auto;
  width: 90%;
}

.club-activity .content .txt h2 {
  margin: 10px 10px 10px 15px;
}

.club-activity .content .txt span {
  display: inline-block;
  margin: 10px 0 20px 15px;
}

/* 俱乐部活动-start */
</style>
